import React from 'react';
import { Routes, Route, Navigate } from 'react-router-dom';
import peptideRoutes from '../../routes/peptide.js';
import { Helmet } from 'react-helmet';
import Topbar from '../../component/EliteGame/topbar.jsx';

const Peptides = () => {
  return (
    <div className="min-h-screen">
      <Helmet>
        <meta charSet="utf-8" />
        <title>Peptides Management</title>
      </Helmet>

      <div className="mx-4 shadow-sm border-b">
        <div className="flex justify-between items-center py-4">
          <Topbar title={'Peptides Management'} />
        </div>
      </div>

      <main className="flex-1">
        <Routes>
          <Route index element={<Navigate to="/peptides/dashboard" replace />} />
          {peptideRoutes.map((route, index) => (
            <Route key={index} path={route.path} element={<route.component />} />
          ))}
        </Routes>
      </main>
    </div>
  );
};

export default Peptides;
